/**
 * Router Permissions Matrix
 * Ánh xạ giữa URL path và mã quyền (permission_key) tương ứng.
 * Mọi route bảo mật đều phải được khai báo tại đây.
 */

export const routerPermissions: Record<string, string> = {
  // Settings & System
  '/settings': 'system.settings.view',
  '/settings/members': 'users.view',
  '/settings/roles': 'roles.view',
  '/settings/categories': 'system.settings.view',
  '/settings/warehouses': 'inventory.settings',
  '/settings/partners': 'system.settings.view',
  
  // Dashboard
  '/': 'dashboard.view',
  '/dashboard': 'dashboard.view',

  // Inventory
  '/inventory': 'inventory.view',
  '/inventory/new': 'inventory.create',
  
  // Projects & Construction
  '/projects': 'projects.view',
  '/documents': 'documents.view',
  '/work-orders': 'work_orders.view',
  '/zones': 'zones.view',

  // Estimates & Cost
  '/estimates': 'estimates.view',
  '/estimates/new': 'estimates.create',
  '/estimates/norms': 'estimates.norms.view',
  '/estimates/norms/new': 'estimates.norms.create',
  '/estimates/process-templates': 'estimates.process_templates.view',
  '/estimates/process-templates/new': 'estimates.process_templates.create',
  '/estimates/rates': 'estimates.view_cost',
  '/estimates/rates/form': 'estimates.override_price',

  // Maintenance & Assets
  '/equipment': 'equipment.view',
  '/utility': 'utility.view',
  '/agro': 'agro.view',

  // General Ops
  '/requests': 'requests.view',
  '/reports': 'reports.view',
  
  // Approvals
  '/approvals': 'approvals.view',

  // Teams & Users
  '/teams': 'teams.view',
  '/users': 'users.view',
  
  // Admin & Security Center
  '/admin/users': 'super_admin.only',
  '/admin/companies': 'system.settings.view',
  '/permissions': 'system.settings.view',
  '/roles': 'roles.view',
};

/**
 * Hàm tìm kiếm mã quyền từ URL hiện tại
 * Hỗ trợ nhận diện các route có tham số (VD: /settings/members/123 -> /settings/members)
 */
export function getRequiredPermissionForRoute(pathname: string): string | null {
  // 1. Khớp chính xác hoàn toàn
  if (routerPermissions[pathname]) {
    return routerPermissions[pathname];
  }

  // 2. Tìm kiếm theo pattern (khớp tiền tố dài nhất)
  // Ví dụ: /settings/members/123 -> tìm /settings/members
  const segments = pathname.split('/').filter(Boolean);
  
  while (segments.length > 0) {
    const pathToCheck = '/' + segments.join('/');
    if (routerPermissions[pathToCheck]) {
      return routerPermissions[pathToCheck];
    }
    segments.pop();
  }

  // 3. Fallback: Nếu không khai báo, hệ thống sẽ trả về null (sẽ bị Default Deny)
  return null;
}

/**
 * Danh sách các route đã đăng nhập là được phép truy cập (Không cần kiểm tra quyền)
 */
export const baseAuthenticatedRoutes = [
  '/profile',
  '/help',
  '/notifications',
  '/docs'
];
